import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { MaterialState } from './material.types';

import type { MaterialModel } from '~/core/models';

const initialState: MaterialState = {
  selectedMaterial: undefined,
  restorableMaterial: undefined,
};

const materialSlice = createSlice({
  name: 'material',
  initialState,
  reducers: {
    updateRestorableMaterial: (
      state,
      action: PayloadAction<Partial<MaterialModel>>
    ) => {
      state.restorableMaterial = action.payload;
    },
    updateSelectedMaterial: (state, action: PayloadAction<MaterialModel>) => {
      state.selectedMaterial = action.payload;
    },
    resetSelectedMaterial: (state) => {
      state.selectedMaterial = undefined;
    },
  },
});

export const {
  updateRestorableMaterial,
  updateSelectedMaterial,
  resetSelectedMaterial,
} = materialSlice.actions;

export default materialSlice.reducer;
